import clsx from 'clsx';
import { X } from 'lucide-react';
import React, { PropsWithChildren, ReactNode } from 'react';
import styles from './Chip.module.scss';

const colorMapping = {
  primary: { background: 'var(--color-primary)', text: 'var(--color-primary-contrast)' },
  secondary: { background: 'var(--color-secondary)', text: 'var(--color-secondary-contrast)' },
  neutral: { background: 'var(--color-neutral)', text: 'var(--color-neutral-contrast)' },
  white: { background: 'var(--white)', text: 'var(--white-contrast)' },
};

export type ChipColor = keyof typeof colorMapping;

export type ChipProps = PropsWithChildren<{
  icon?: ReactNode;
  clickable?: boolean;
  deletable?: boolean;
  href?: string;
  color?: ChipColor;
  onClick?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
  onDelete?: React.MouseEventHandler<HTMLSpanElement>;
}>;

const Chip: React.FC<ChipProps> = ({
  children,
  icon,
  clickable,
  deletable,
  href,
  color = 'neutral',
  onClick,
  onDelete,
}) => {
  const Root = href ? 'a' : 'div';

  return (
    <Root
      className={clsx(styles.chip, { [styles.clickable]: Boolean(clickable || onClick || href) })}
      href={href}
      style={{ color: colorMapping[color].text, backgroundColor: colorMapping[color].background }}
      onClick={onClick}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{children}</span>
      {deletable && (
        <span className={clsx(styles.icon, styles.delete)} onClick={onDelete}>
          <X size={16} />
        </span>
      )}
    </Root>
  );
};

export default Chip;
